import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "kd-icon-check-mark",
  "use": "kd-icon-check-mark-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"kd-icon-check-mark\"><path d=\"M64 512s231.68 192 256 350.72c0 0 304-497.28 640-542.08a188.16 188.16 0 0 1-69.12-192s-186.88 17.28-540.8 565.12L184.96 413.44z\" p-id=\"1801\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol